import React from 'react';
import './index.scss';
import { Dialog } from '../../components/Dialog';
import * as api from '../../services/api';
import en from '../../locales/en-US.json';
import zh from '../../locales/zh-Hans.json';
import urlparser from 'urlparser';
import { Button, message, Modal } from 'antd';
import moment from 'moment';
import ReactGA from 'react-ga';
import PCOpenPhoneTrialYearSuccess from '../../components/PCInputPhoneTrial/PCOpenPhoneTrialYearSuccess';
import PCInputPhoneTrialYear from '../../components/PCInputPhoneTrial/PCInputPhoneTrialYear';
import { getCode } from '../../services/api';
import { baseTurnUrl } from '../../services/api';


export interface IInviteProps  {
  logo: string,
  inviterId: string;
  trailId: string;
  qrcode:string;
  activityTime:any;
  privilegesDays:any;
  description:any;
  userRegisterType:any;
  state:any;
}

interface IState {
  errMsg: string;
  showErr: boolean;
  email: string;
  lang: string;
  showDialog: boolean;
  message: any;
  jwt: string;
  time: string;
  custom: any;
  title: string;
  disabled: boolean;
  isWeChat: string;
  buttonUrl: string;
  logo: string;
  inviterId: string;
  trailId: string;
  showVip: string;
  inputEmail: boolean;
  openSuccess: any;
  qrcode:string;
  activityTime:any;
  description:any;
  privilegesDays:any;
  userRegisterType:any;
  state:string;
  type:string | any;
  selected:any;
  sourceId:any;
  animateClass:string;
}

interface IParams {
  jwt: string;
  isWeChat: string;
  weChatButtonUrl: string;
  logo: string;
  inviterId: string;
}

export interface ITrialRes {
  time: number;
  error?: string;
  body?: {
    days: number;
  };
}

export class YearPage extends React.Component<IInviteProps , IState> {
  public readonly state: Readonly<IState> = {
    errMsg: '',
    showErr: false,
    email: '',
    lang: 'zh-Hans',
    showDialog: false,
    message: {
      'zh-Hans': zh,
      'en-US': en
    },
    jwt: '',
    time: '',
    custom: '',
    title: '',
    disabled: false,
    isWeChat: '',
    buttonUrl: '',
    logo: '',
    inviterId: '',
    trailId: '',
    showVip: 'personal',
    inputEmail: false,
    openSuccess: false,
    qrcode:'',
    activityTime:{},
    description:'',
    privilegesDays:'',
    userRegisterType:'',
    state:'',
    type:'tab1',
    selected:'tab1',
    animateClass:'show-up',
    sourceId:'',
  };

  UNSAFE_componentWillMount() {
    let url = urlparser.parse(window.location.href);
    document.title='免费领上百套年终总结PPT模板，新用户注册送3天VIP会员！';
    let path = url.path.base;
    if (path.split('/')[1] === 'en') {
      this.setState({ lang: 'en-US' });
    }
  }

  componentDidMount() {
    this.setState(
      {
        trailId: this.props.trailId,
        logo: this.props.logo,
        inviterId: this.props.inviterId,
        qrcode:this.props.qrcode,
        activityTime:this.props.activityTime,
        description:this.props.description,
        privilegesDays:this.props.privilegesDays,
        userRegisterType:this.props.userRegisterType,
        state:this.props.state
      });
  }
  openInput=(id?:any)=>{
      if(localStorage.getItem('token')){
        this.turnTo(id);
      }else{
        this.setState({
            inputEmail:true,
            sourceId:id||''
        })
      }
  }
  turnTo=(id?:any)=>{
    if(localStorage.getItem('token')){
        getCode().then(res=>{
            if(res.error){
                res.error.message&&message.warning(res.error.message);
                localStorage.removeItem('token');
            }else{
                const code = res.body.code
                if(id){
                    window.location.href=`${baseTurnUrl}/ppt/template/${id}.html?code=${code}`
                }else{
                    window.location.href=`${baseTurnUrl}/ppt/template?code=${code}`
                }
                this.setState({
                    sourceId:''
                })
            }
        })
    }else{
        if(id){
            window.location.href=`${baseTurnUrl}/ppt/template/${id}.html`
        }else{
            window.location.href=`${baseTurnUrl}/ppt/template/`
        }
    }
  }
  render() {
    const { showVip, inputEmail, openSuccess,trailId,inviterId,time,logo,qrcode,activityTime,description,privilegesDays,userRegisterType,state,type,animateClass,selected,sourceId } = this.state;
    return (
      <div className={'year-page-box'}>
      <div className={'year-page'}>
        <div className={'year-page-wrap'}>
        <div className={'year-page-head'}>
          <div className={'year-page-head-left'}>
            <div className={'year-page-logo'}>
              <img src={require('../../assets/year/logo.svg')} alt=""/>
            </div>
            <div className={'year-page-head-one'}>
              还在因为你的年终总结 PPT 
              而困扰吗？
            </div>
            <div className={'year-page-head-two'}>
              {
                headDataList.map(it=>{
                  return <div className={'year-page-head-item'} key={it.name}>
                    <div className={'year-page-head-name'}>{it.name}</div>
                    <div className={'year-page-head-title'}>{it.title}</div>
                  </div>
                })
              }
            </div>
          </div>
          <div className={'year-page-head-right'}>
            <img style={{height:307}} src={require('../../assets/year/pic.png')}/>
          </div>
        </div>
        <div className={'year-page-intro'}>
            {
              introList.map((it,index)=>{
                return index==1?<div key={it.name} className={'year-page-intro-special-item'}>
                  <img className={'year-page-intro-item-divider'} src={require('../../assets/year/divider.png')} alt="" />
                  <div className={'year-page-intro-item'}>
                  <div className={'year-page-intro-item-left'}>
                    <div className={'year-page-intro-item-name'}>{it.name}</div>
                    <div className={'year-page-intro-item-box'}>
                      <div className={'year-page-intro-item-title'}>{it.title}</div>
                      <div className={'year-page-intro-item-type'}>{it.type}</div>
                    </div>
                  </div>
                  <img style={{height:56}} src={it.img} alt="" />
                </div>
                  <img className={'year-page-intro-item-divider'} src={require('../../assets/year/divider.png')} alt="" />
                </div>:
                <div key={it.name} className={'year-page-intro-item'}>
                  <div className={'year-page-intro-item-left'}>
                    <div className={'year-page-intro-item-name'}>{it.name}</div>
                    <div className={'year-page-intro-item-box'}>
                      <div className={'year-page-intro-item-title'}>{it.title}</div>
                      <div className={'year-page-intro-item-type'}>{it.type}</div>
                    </div>
                  </div>
                  <img style={{height:56}} src={it.img} alt="" />
                </div>
              })
            }
        </div>
        <div className={'year-page-content'}>
          <div className={'year-page-content-head'}>
            <div className={'year-page-content-head-left'}>
              <div className={'year-page-content-head-title'}>精选年终总结案例</div>
              <div className={'year-page-content-head-tags'}>
                {
                  tabList.map(it=>{
                    return <div className={'year-page-content-head-tag'} 
                            key={it.key}
                            onClick={()=>this.openInput()} 
                            onMouseEnter={()=>type!==it.key&&this.setState({
                              selected:it.key,
                              animateClass:'hide-down'},()=>{
                              setTimeout(()=>{
                                this.setState({
                                  type:it.key,
                                  animateClass:'show-up'
                                })
                              },400)
                            })}
                            style={it.key===selected?{background:"#E4E9EF"}:{}}
                            >
                      {it.title}
                    </div>
                  })
                }
            </div>
            </div>
            <div className={'year-page-content-head-right'} onClick={()=>this.openInput()}>
                <span>更多</span>
                <img src={require('../../assets/year/drop.png')} alt="" />
            </div>
          </div>
          <div className={`year-page-content-box ${animateClass}`}>
              {
                tabData[type].map((it:any)=>{
                  return <div className={'year-page-content-item'} key={it.id} onClick={()=>this.openInput(it.id)}>
                      <img className={'year-page-content-item-img'} src={it.thumbnail} alt="" />
                      <div className={'year-page-content-item-title'}>{it.title}</div>
                      {it.group&&it.group.icon&&!!it.group.icon.data&&<img className={'year-page-content-item-icon'} src={it.group.icon.data}/>}
                      {it.newResources&&<img className={'year-page-content-item-new'} src={require('../../assets/year/new.png')}/>}
                  </div>
                })
              }
          </div>
        </div>
        <div className={'year-page-bottom-action'}>
          <div className={'year-page-bottom-action-wrap'}>
            <div className={'year-page-botton-action-item'}>
              <img src={require('../../assets/year/icon_fire.png')}/>
              <span className={'year-page-botton-action-title'}>上百套行业年终总结的主题模板，原创首发，直接一键套用！</span>
            </div>
            <div className={'year-page-botton-action-item'}>
              <span className={'year-page-botton-action-text'}>已有 19302 人领取</span>
          <Button className={'year-page-botton-action-button'} type={'primary'}
                  onClick={() => {
                    ReactGA.pageview(window.location.pathname+`/${privilegesDays}days/free/click`);
                    this.setState({ inputEmail: true })}}>
            免费领取
          </Button>
          </div>
          </div>
        </div>
        <PCInputPhoneTrialYear ReactGA={ReactGA} privilegesDays={privilegesDays} visible={inputEmail} onClose={(e: any, time?: any) => {
            this.setState({ inputEmail: false });
            if (e === true) {
              ReactGA.pageview(window.location.pathname+`/${privilegesDays}days/phone/success`);
              this.setState({ openSuccess: true, time: time });
            }else if(e==='old'){
                ReactGA.pageview(window.location.pathname+`/${privilegesDays}days/phone/old/login`);
                this.setState({ openSuccess: 'old', time: time });
            }else{
                ReactGA.pageview(window.location.pathname+`/${privilegesDays}days/phone/cancel`);  
            }
          }} trailId={trailId} inviterId={inviterId} state={state}/>
          <PCOpenPhoneTrialYearSuccess visible={openSuccess} time={time} onClose={() =>{ this.setState({ openSuccess: false });this.turnTo(sourceId);}}/>
         </div>
      </div>
      </div>
    );
  }
}
const headDataList=[
  {
    name:'演示汇报',
    title:'繁多'
  },
  {
    name:'内容呈现',
    title:'凌乱'
  },
  {
    name:'编辑排版',
    title:'耗时'
  },
  {
    name:'素材版权',
    title:'风险'
  },
]
const introList=[
  {
    title:'年+',
    name:'14',
    type:"行业经验",
    img:require('../../assets/year/icon_industry.png'),
  },
  {
    title:'万+',
    name:'1400',
    type:"用户使用",
    img:require('../../assets/year/icon_user.png'),
  },
  {
    title:'万+',
    name:'30',
    type:"PPT素材",
    img:require('../../assets/year/icon_ppt.png'),
  }
]
const tabList=[
  {
    key:'tab1',
    title:'销售业务'
  },
  {
    key:'tab2',
    title:'项目总结'
  },
  {
    key:'tab3',
    title:'市场总结'
  },
  {
    key:'tab4',
    title:'采购汇报'
  },
  {
    key:'tab5',
    title:'财务总结'
  },
  {
    key:'tab6',
    title:'安全生产'
  },
  {
    key:'tab7',
    title:'人力资源'
  },
  {
    key:'tab8',
    title:'客服工作'
  },
]
const tabData:any={
  "tab1": [
      {
          "id": 277154,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-05-26/060932/4e304d5e-df38-4418-95a3-83495248c0a3.jpeg",
          "title": "蓝色商务年终工作总结数据分析总结汇报PPT模板",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 309281,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-09-12/092221/c1743463-80cf-4aee-a771-b0561034d2f1.jpeg",
          "title": "紫色简约风公司项目汇报工作总结PPT模板",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 316198,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-10-10/020930/b53d3965-23e9-4834-baf4-df056af98ab6.jpeg",
          "title": "多色商务工作总结培训课件PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 319239,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-10-15/100054/5d8e8c2c-be14-40ed-be44-c96263a31c2e.jpeg",
          "title": "黑色商务工作总结汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 352905,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-01-08/183132/06a533d5-451c-4902-bea5-83b0303593a7.thumbnail.zh-Hans.jpg",
          "title": "棕色创意商务旅游旅行工作总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 418455,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-05-09/140323/a5fcc701-4b6a-4536-a53c-fed6aa475a37.thumbnail.zh-Hans.jpg",
          "title": "灰色人工作总结报告PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 500747,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-11-13/191840/d4b581ed-7d97-49df-9f7b-1d1b6ffe9c48.thumbnail.zh-Hans.png",
          "title": "蓝色年度工作总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 520757,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-18/191341/e12d54cb-6b1c-43b0-8b45-a30bdfce0f1e.thumbnail.zh-Hans.png",
          "title": "红色年度总结汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 778647,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2021-11-09/143930/e4367fa9-a556-466a-977e-8ad1800cc3b4.thumbnail.zh-Hans.png",
          "title": "蓝色简约石油能源行业年终工作总结PPT模板",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      }
  ],
  "tab2": [
      {
          "id": 334052,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-11-25/094908/e57847d6-9a70-402c-b652-c0a832b46737.thumbnail.zh-Hans.jpg",
          "title": "白色商务金融保险银行工作总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 381000,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-03-13/161326/70ed7aa3-f8ad-46ac-9a60-c573418e38ad.thumbnail.zh-Hans.jpg",
          "title": "红色商务工作总结毕业答辩PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 381027,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-03-13/161922/c81ef49a-8770-42ae-9226-a0850bc31cd7.thumbnail.zh-Hans.jpg",
          "title": "蓝色科技智能培训课件PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 511978,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-04/202054/7eefc730-c41e-4a12-b700-31c2d1421161.thumbnail.zh-Hans.png",
          "title": "紫色年终总结汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 516250,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-11/181232/9e4c9181-3fed-4a4f-a78b-922b62a05457.thumbnail.zh-Hans.png",
          "title": "绿色年终总结汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 520801,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-18/193826/0f6fe235-0a9b-475a-b03a-54634b2734db.thumbnail.zh-Hans.png",
          "title": "20XX年终工作总结汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 528256,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-31/182424/bd8a75db-eed3-417e-987f-72d1e9481736.thumbnail.zh-Hans.png",
          "title": "黑色年终工作总结汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 654844,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2021-08-30/111941/5f7b0a41-65d7-45e9-b13c-76389962f489.thumbnail.zh-Hans.png",
          "title": "白色3D简约财务会计PPT年终总结模板",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
        "id": 778644,
        "thumbnail": "https://static.islide.cc/site/content/thumbnail/2021-11-09/143707/7ffedb7e-bc3d-4f38-b107-6752dbedb4a3.thumbnail.zh-Hans.png",
        "title": "黑色商务公司财务部门年度工作汇报PPT素材下载",
        "type": "template",
        "newResources": true,
        "group": {
            "id": 2,
            "name": "高级",
            "icon": {
                "type": "url",
                "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
            }
        }
    }
  ],
  
  "tab3": [
      {
          "id": 309067,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-09-12/085327/467b0a5f-e8a7-44b1-b73b-8f09a1c1e9b9.jpeg",
          "title": "灰色商务工作总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 309296,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-09-12/092436/efe0fa27-ac57-460f-8f20-db834bb9a16f.jpeg",
          "title": "多色商务工作总结培训课件PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 316207,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-10-10/020942/fba705c1-bf5c-48b2-8a5f-fe67e5be915e.jpeg",
          "title": "白色插画工作总结培训课件PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 334085,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-12-03/070930/2e0eea7f-6acd-40cd-8559-18191aae150f.thumbnail.zh-Hans.jpg",
          "title": "多色年终个人工作总结汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 349106,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-01-09/110622/15b1203d-76bb-4793-bd21-12476fef1f12.thumbnail.zh-Hans.jpg",
          "title": "多色插画年末个人总结汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 363846,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-02-18/094659/60dbcc64-0357-4fd9-b491-e6381327d36a.thumbnail.zh-Hans.jpg",
          "title": "多色插画竞聘述职工作总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 381002,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-03-13/161328/ac2c4dfa-fa1d-4939-bebc-91b51d546c8a.thumbnail.zh-Hans.jpg",
          "title": "绿色商务培训课件工作总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 495344,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-10-30/184736/0977aa83-5b13-4c60-844c-609e526538f6.thumbnail.zh-Hans.png",
          "title": "蓝色年度工作述职总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 504107,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-11-20/101455/a35255f5-9269-486f-80ae-11955597fbf1.thumbnail.zh-Hans.png",
          "title": "蓝色年度述职汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      }
  ],
  "tab4": [
      {
          "id": 309273,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-09-12/092106/9d3c4ca1-115d-44db-bd9a-32083aabe0a4.jpeg",
          "title": "蓝色插画风格年中工作总结汇报PPT模板下载",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 309290,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-09-12/092428/376a4e0a-cd6f-4a99-b158-134484d92f9b.jpeg",
          "title": "蓝色科技风格企业年度工作总结汇报PPT模板",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 309377,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-09-12/093946/a597701f-657e-47cf-92a6-7b89ec7378aa.jpeg",
          "title": "蓝色大气科技风年终项目总结汇报PPT模板",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 364580,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-03-13/142305/f309b0b3-749a-4bb5-8bc3-8a531d25cb43.thumbnail.zh-Hans.jpg",
          "title": "蓝色科技智能商业计划书市场营销PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 504251,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-11-20/154114/21590977-d99f-439f-88de-3c9b01e7c51a.thumbnail.zh-Hans.png",
          "title": "黑色年终述职报告PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 512062,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-04/205846/e34c6f2f-47ec-4c8a-a9d0-77dc49cb0dbc.thumbnail.zh-Hans.png",
          "title": "蓝色年度岗位工作述职报告PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 516248,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-11/181229/0e9b735f-d952-4a51-9109-d2d3645d580d.thumbnail.zh-Hans.png",
          "title": "工作总结及未来规划PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 516249,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-11/181230/1f1a1d5d-061a-4fd1-a140-2b55f7fef361.thumbnail.zh-Hans.png",
          "title": "黑色年度工作总结汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 520809,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-18/202231/09d9ed21-da96-4c36-bf61-1b32f07f094c.thumbnail.zh-Hans.png",
          "title": "黑色工作述职汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      }
  ],
  "tab5": [
      {
          "id": 309895,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-09-16/024157/f695d64b-f575-429f-8f89-d5a689cd6d63.jpeg",
          "title": "黑色创意商务地产工作总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 378603,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-03-12/121038/01ec7675-cd1c-4771-aa66-032fed146c15.thumbnail.zh-Hans.jpg",
          "title": "蓝色个人年度工作总结报告PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 381024,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-03-13/161918/92a2fa7a-5d70-4ba7-af39-eb5650a2775a.thumbnail.zh-Hans.jpg",
          "title": "蓝色插画教育培训培训课件PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 504253,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-11-20/154150/06a24bf8-9914-483d-8598-cf19d52a98ca.thumbnail.zh-Hans.png",
          "title": "年终工作总结暨新年计划PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 516149,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-11/175104/421047e4-cfcd-4afb-8fee-aaea4c9fcfac.thumbnail.zh-Hans.png",
          "title": "蓝色简约工作总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 516150,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-11/175105/8ff1af95-de0d-4c9e-94bc-339065f1de13.thumbnail.zh-Hans.png",
          "title": "红色商务工作总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 520803,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-18/193828/e0753835-49b3-4faa-b73d-a4ff93602eb4.thumbnail.zh-Hans.png",
          "title": "黑色年度工作总结汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 751307,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2021-09-12/153758/f1ba5d5c-af9e-4731-a8ad-b8c85c5049b5.thumbnail.zh-Hans.png",
          "title": "红色商务年终工作计划总结及未来规划PPT素材下载",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 771669,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2021-10-26/182827/f71e11ab-e5c1-476d-981b-ecee090c93be.thumbnail.zh-Hans.png",
          "title": "绿色商务人力资源年终工作总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      }
  ],

  "tab6": [
      {
          "id": 381009,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-03-13/161552/3d1b0222-ad29-4ea1-9407-ae0aefe85703.thumbnail.zh-Hans.jpg",
          "title": "蓝色简约工作总结毕业答辩PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 511977,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-04/202053/5973154d-fab0-462e-8b86-3351d7231141.thumbnail.zh-Hans.png",
          "title": "黑色年终总结汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 511980,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-04/202210/19fe2de8-e4c3-4658-b5cb-47c1ad6a6a26.thumbnail.zh-Hans.png",
          "title": "年终总结暨未来归来PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 511982,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-04/202213/e0754c4b-f1bb-4db9-be81-436a47ee82d2.thumbnail.zh-Hans.png",
          "title": "年终总结暨新年计划",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 1,
              "name": "免费",
              "icon": {
                  "type": "url",
                  "data": null
              }
          }
      },
      {
          "id": 520753,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-18/191239/6ca85291-379d-41d7-a3d8-70b2f2536fb6.thumbnail.zh-Hans.png",
          "title": "蓝色年度工作述职报告PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 520811,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-18/202233/d257a274-5dca-4be1-b050-2e2b34f3d745.thumbnail.zh-Hans.png",
          "title": "市场工作总结及未来规划PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 528254,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-31/182417/53b6d652-b35f-4cbc-be9c-e1263ee0d9e4.thumbnail.zh-Hans.png",
          "title": "黑色商务年终总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 771668,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2021-10-26/182826/f1cddebe-042d-467f-a989-ee22858c0818.thumbnail.zh-Hans.png",
          "title": "市场经理年终工作总结汇报PPT模板下载",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 778641,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2021-11-09/143548/32c77030-e8b7-4753-b29c-ce6e9460fab8.thumbnail.zh-Hans.png",
          "title": "蓝色保险集团企业发展规划年终报告PPT模板下载",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      }
  ],
  "tab7": [
      {
          "id": 500733,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-11-13/174044/2e4d4ce1-63ea-4e06-8b5b-d1e8ed8dec97.thumbnail.zh-Hans.png",
          "title": "蓝色年终总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 511976,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-04/202052/56916c53-492e-4f13-9558-4234ca1724d4.thumbnail.zh-Hans.png",
          "title": "黑色年终总结汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 511981,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-04/202212/cf2368f9-3b46-4c75-9b79-244f97707631.thumbnail.zh-Hans.png",
          "title": "年度工作总结暨工作计划PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 516111,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-11/174407/091827ba-1126-4ab2-b5ef-e30a2d27a0d7.thumbnail.zh-Hans.png",
          "title": "年终品牌推广总结及未来规划PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 520751,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-18/191235/0fdfedfe-0540-47eb-ba10-88e692eaa37d.thumbnail.zh-Hans.png",
          "title": "年度述职报告PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 520810,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-18/202232/5c7762ad-09f0-4e3d-ac7b-a2acf9d3b945.thumbnail.zh-Hans.png",
          "title": "品牌推广总结及未来规划PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 527542,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-30/202837/af2ac8d6-6886-46c5-bd36-e523ffebfb4c.thumbnail.zh-Hans.png",
          "title": "品牌推广总结及未来规划PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 638991,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2021-07-26/095828/e5a3e605-158a-452a-824f-b6de1d081993.thumbnail.zh-Hans.png",
          "title": "金色商务房地产拓客引流方案PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 779472,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2021-11-10/101555/ebcda2ca-2e9a-4899-b887-428a091e27a3.thumbnail.zh-Hans.png",
          "title": "橙色商务团建活动项目年终总结PPT案例模板",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      }
  ],
  "tab8": [
      {
          "id": 299374,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-08-14/031412/1730a391-5f2a-417b-bc8f-4248d9d10ad4.jpeg",
          "title": "蓝色商务销售部门工作总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 333999,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2019-12-03/063925/52681667-c20b-4daf-ad81-e16e4d76f70e.thumbnail.zh-Hans.jpg",
          "title": "蓝色销售部门个人工作总结报告PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 507764,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-11-27/183119/94145b04-339a-4167-a491-8152eba3e7e8.thumbnail.zh-Hans.png",
          "title": "橙色年终总结汇报PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 516151,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-11/175106/b7d3a825-6f5e-4184-b6a2-0289978c52ab.thumbnail.zh-Hans.png",
          "title": "黑色商务工作总结PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 518060,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-14/200235/fc91fdbb-c4f9-4e7d-b31c-d8e5c516551f.thumbnail.zh-Hans.png",
          "title": "红色企业年度总结暨颁奖盛典PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 520752,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-18/191237/576aa67a-c807-4b2c-a471-091e181d3027.thumbnail.zh-Hans.png",
          "title": "黑色年终述职报告PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 520756,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2020-12-18/191340/c19b3098-1210-4d09-9df4-e0c11baa7acb.thumbnail.zh-Hans.png",
          "title": "黑色年度工作述职PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 625692,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2021-07-05/093632/826a045e-de38-4a1f-80ef-be1c1625d875.thumbnail.zh-Hans.png",
          "title": "橙色商务地产行业市场营销PPT案例",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      },
      {
          "id": 771671,
          "thumbnail": "https://static.islide.cc/site/content/thumbnail/2021-10-26/182910/039a78f4-3f7f-480e-b60e-d83b1b35aca6.thumbnail.zh-Hans.png",
          "title": "蓝色商务地产商业计划书通用PPT模板",
          "type": "template",
          "newResources": true,
          "group": {
              "id": 2,
              "name": "高级",
              "icon": {
                  "type": "url",
                  "data": "https://static.islide.cc/site/content/group/281887eb1852e97084f0f17ed906186a59da8073.png"
              }
          }
      }
  ],
}